import { jsxs as l, Fragment as g, jsx as a } from "react/jsx-runtime";
import { NextgenDOMPurify as _ } from "@nextgen-web-framework/all";
import '../../assets/TableComponent.css';const z = "#ffffff", V = "#396e75", f = "#e5fdff", C = "#546223", k = "#f0fae5", u = "#a65523", b = "#fff1e8", p = "#7f3e3e", w = "#ffe2e2", B = "#62625a", y = "#f8f8e7", O = "#38539a", G = "#707070", N = "#c8f8d1", R = "#87c9c8", W = "#5291b1", $ = "rgba(82, 145, 177, 0.1019607843)", T = "#445685", v = "#181d61", x = "rgba(24, 29, 97, 0.1019607843)", A = "#5969d6", Y = "#ea999d", D = "#b6577e", M = "rgba(182, 87, 126, 0.1019607843)", P = "#7e3e80", S = "#1e247f", j = "rgba(30, 36, 127, 0.1019607843)", H = "#da7600", L = "#107f47", F = "#d91734", q = "_html_ai8cm_38", e = {
  amwayWhite: z,
  darkBlue: V,
  lightBlue: f,
  darkGreen: C,
  lightGreen: k,
  darkOrange: u,
  lightOrange: b,
  darkRed: p,
  lightRed: w,
  darkYellow: B,
  lightYellow: y,
  darkPurple: O,
  darkGrayOnWhite: G,
  dataVizColor1: N,
  dataVizColor2: R,
  dataVizColor3: W,
  dataVizColor3Background: $,
  dataVizColor4: T,
  dataVizColor5: v,
  dataVizColor5Background: x,
  dataVizColor6: A,
  dataVizColor7: Y,
  dataVizColor8: D,
  dataVizColor8Background: M,
  dataVizColor9: P,
  dataVizColor10: S,
  dataVizColor10Background: j,
  dataVizAlertOrange: H,
  dataVizSuccessGreen: L,
  dataVizWarningRed: F,
  "no-visible": "_no-visible_ai8cm_34",
  html: q,
  "cms-table-title": "_cms-table-title_ai8cm_72",
  "cms-table-copmonent": "_cms-table-copmonent_ai8cm_81",
  "theme-purple": "_theme-purple_ai8cm_86",
  "theme-blue": "_theme-blue_ai8cm_92",
  "theme-red": "_theme-red_ai8cm_98",
  "theme-white": "_theme-white_ai8cm_104",
  "theme-gray": "_theme-gray_ai8cm_110",
  "theme-yellow": "_theme-yellow_ai8cm_122",
  "theme-green": "_theme-green_ai8cm_128",
  "theme-orange": "_theme-orange_ai8cm_134",
  "row-data-highlight": "_row-data-highlight_ai8cm_156",
  "row-data-height": "_row-data-height_ai8cm_162",
  "cms-table-footer": "_cms-table-footer_ai8cm_166"
}, K = ({
  theme: i,
  columnList: n,
  footer: c,
  rowData: s,
  title: r
}) => {
  const d = _(c || "", { ADD_ATTR: ["target"] });
  return /* @__PURE__ */ l(g, { children: [
    !!r && /* @__PURE__ */ a("p", { className: e["cms-table-title"], children: r }),
    /* @__PURE__ */ l("table", { className: e["cms-table-copmonent"], "data-testid": "tablecomponent-test-id", "data-pod-name": "commerce", children: [
      /* @__PURE__ */ a("tr", { children: n.map((t) => /* @__PURE__ */ a("th", { children: t.name }, `${t.name}${t._metadata.uid}`)) }),
      s.map((t, m) => /* @__PURE__ */ a("tr", { className: `${e[i]}`, children: t.row.map((o, h) => /* @__PURE__ */ a(
        "td",
        {
          className: h ? "" : e["row-data-highlight"],
          children: /* @__PURE__ */ a("div", { className: e["row-data-height"], children: o.data })
        },
        `${o.data}${o._metadata.uid}`
      )) }, `row-${t.row.length - m}`))
    ] }),
    !!d && /* @__PURE__ */ a("div", { className: e["cms-table-footer"], dangerouslySetInnerHTML: { __html: d } })
  ] });
};
export {
  K as default
};
//# sourceMappingURL=TableComponent.js.map
